// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Nu7_","label":"SetPasswdForm_label__25HFN"};